import { Mui } from "@osu/react-ui";

const NoncompetitiveQualities = (props) => {
  const {
    studentData,
    renderInputControls
  } = props; 

  return (
    <div style={{ display: "flex" }}>
      <Mui.FormControl component="fieldset">
        <Mui.FormLabel component="legend">
          {studentData?.data?.notes?.noncompetitive && <Mui.Typography variant="h6" component="h3">
            Non-Competitive Application Attributes
          </Mui.Typography>}
        </Mui.FormLabel>
        <Mui.FormGroup>
        {renderInputControls(studentData?.data?.notes?.noncompetitive, "noncompetitive")}
        </Mui.FormGroup>
      </Mui.FormControl>
    </div>
  );
};

export default NoncompetitiveQualities;
